'use es6';

import { combineReducers } from 'redux';
import PresentationReducer from './view/Presentation';
import PdfReducer from './view/Pdf';
import MeetingLink from './view/MeetingLink';
export default combineReducers({
  presentation: PresentationReducer,
  pdf: PdfReducer,
  meetingLink: MeetingLink
});